import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import FormGroup from '../helpers/FormGroup'
import PersonForm from '../helpers/PersonForm'
import axios from 'axios'

class CompanyPeople extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      person: {first_name: "", size: "", errors: {}}
    }
  }

  setPersonData = (data) => {
    const personData = {...this.state.person, ...data}
    if(personData.errors) {
      Object.keys(data).forEach((key) => personData.errors[key] = null)
    }
    this.setState({person: personData})
  }

  save = (callback) => {
    const url = `/onboarding/form/${this.props.data.id}/person`

    return axios.post(url, {person: this.state.person})
      .then((response) => {
        let people = this.props.data.people.filter((person) => person.id != this.state.person.id)
        people = [...people, response.data.person]
        this.props.setData({people: people})
        this.resetForm()
      })
      .catch((error) => {
        if(error.response && error.response.data && error.response.data.person) {
          this.setState({person: error.response.data.person})
        } else {
          alert("There was an error submitting your information to the server, please try again")
        }
      })
  }

  resetForm = () => {
    this.setState({
      person: {first_name: "", size: "", errors: {}}
    })
  }

  removePerson = (id) => {
    const person = this.props.data.people.find((person) => person.id == id)
    const people = this.props.data.people.filter((person) => person.id != id)
    this.props.setData({people: people})

    const url = `/onboarding/form/${this.props.data.id}/remove_person`
    return axios.post(url, {person: person})
      .then((response) => {})
      .catch((error) => {
        alert("There was an error submitting your information to the server, please try again")
      })
  }

  loadPerson = (id) => {
    const person = this.props.data.people.find((person) => person.id == id)
    this.setState({person: person})
  }

  render() {
    const values = this.props.data
    const setData = this.setData

    const jacketSizes = [
      'Womens XS',
      'Womens S',
      'Womens M',
      'Womens L',
      'Womens XL',
      'Mens S',
      'Mens M',
      'Mens L',
      'Mens XL',
      'Mens XXL'
    ]

    return(
      <>
        <div className="col-12 col-md-10 col-lg-8 col-xl-6 order-2 order-lg-1">
          <fieldset className="fieldset">
            <legend className="h2">Tell us about your leadership team</legend>
            <PersonForm person={this.state.person} setData={this.setPersonData} />
            {this.state.person.id ?
              <div onClick={this.save} style={{marginTop:'1rem', 'cursor': 'pointer'}}>
                <strong className="button button-large btn-next">Update</strong>
              </div>
              :
              <div onClick={this.save} style={{marginTop:'1rem', 'cursor': 'pointer', 'textAlign':'right'}}>
                <strong className="button button-large btn-next">+ Add this person</strong>
              </div>
            }
          </fieldset>
        </div>
        <div className="col-12 col-lg-4 col-xl-6 order-1 order-lg-2">
          <div className="pl-lg-4 pt-lg-5">
            {values.people.length > 0 ?
              <div className="h4 mb-3" style={{marginBottom:'1rem'}}>People added</div>
              :
              ""
            }
            <ul>
            {values.people.map((person) =>
              <li key={person.id} className="p-sm"  style={{marginBottom:'1rem'}}>
                <div>
                  <strong>
                    {person.first_name} {person.last_name} &nbsp;
                  </strong>
                  {person.title}
                  <div style={{display:'none'}}>{person.email}</div>
                </div>
                <div>
                  <small onClick={(e) => this.loadPerson(person.id)} className="canaan-blue mr-2" style={{'cursor': 'pointer'}}>Edit</small>
                  <small onClick={(e) => this.removePerson(person.id)} className="canaan-blue" style={{'cursor': 'pointer'}}>Remove</small>
                </div>
              </li>
            )}
            </ul>
          </div>
        </div>
      </>
    )
  }
}

export default CompanyPeople